module.exports = __webpack_public_path__ + "static/media/kernelcon_hilton7.0c069d16.jpg";